 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXTCOVER from '@/components/Text/cover'
 import TEXTPRAISE from '@/components/Text/Praise'
 import TEXTTITLE from '@/components/Text/Title'
 import TEXTCOPYRIGHT from '@/components/Text/Copyright'
 import TEXTDEDICATION from '@/components/Text/Dedication'
 import TEXTCONTENTS from '@/components/Text/Contents'
 import TEXTEPIGRAPH from '@/components/Text/Epigraph'
 import TEXTFOREWORD from '@/components/Text/Foreword'
 import TEXTINTRODUCTION from '@/components/Text/Introduction'
 import TEXT1 from '@/components/Text/1'
 import TEXT2 from '@/components/Text/2'
 import TEXT3 from '@/components/Text/3'
 import TEXT4 from '@/components/Text/4'
 import TEXT5 from '@/components/Text/5'
 import TEXT6 from '@/components/Text/6'
 import TEXT7 from '@/components/Text/7'
 import TEXT8 from '@/components/Text/8'
 import TEXT9 from '@/components/Text/9'
 import TEXTACKNOWLEDGMENTS from '@/components/Text/Acknowledgments'
 import TEXTINDEX from '@/components/Text/Index'
 import TEXTAUTHOR from '@/components/Text/Author'
 import TEXTBACKAD from '@/components/Text/BackAd'
 import TEXTBACKAD2 from '@/components/Text/BackAd2'
 import TEXTEXCERPT from '@/components/Text/Excerpt'
 import TEXTNAV from '@/components/Text/nav'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Text/cover",
 			"name" : "Text/cover",
 			"component" : TEXTCOVER
 		},
 		{
 			"path" : "/Text/Praise",
 			"name" : "Text/Praise",
 			"component" : TEXTPRAISE
 		},
 		{
 			"path" : "/Text/Title",
 			"name" : "Text/Title",
 			"component" : TEXTTITLE
 		},
 		{
 			"path" : "/Text/Copyright",
 			"name" : "Text/Copyright",
 			"component" : TEXTCOPYRIGHT
 		},
 		{
 			"path" : "/Text/Dedication",
 			"name" : "Text/Dedication",
 			"component" : TEXTDEDICATION
 		},
 		{
 			"path" : "/Text/Contents",
 			"name" : "Text/Contents",
 			"component" : TEXTCONTENTS
 		},
 		{
 			"path" : "/Text/Epigraph",
 			"name" : "Text/Epigraph",
 			"component" : TEXTEPIGRAPH
 		},
 		{
 			"path" : "/Text/Foreword",
 			"name" : "Text/Foreword",
 			"component" : TEXTFOREWORD
 		},
 		{
 			"path" : "/Text/Introduction",
 			"name" : "Text/Introduction",
 			"component" : TEXTINTRODUCTION
 		},
 		{
 			"path" : "/Text/1",
 			"name" : "Text/1",
 			"component" : TEXT1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js